import { SortDescriptor } from '@progress/kendo-data-query';
import * as Types from './types'

export const emptyState: Types.SortableData<any> = []

export const emptyViewState: Types.SortableViewState = {
  isLoading: false,
  sort: [],
}

export const identitySort: SortDescriptor = {
  dir: 'asc',
  field: 'id',
}



// WEBPACK FOOTER //
// ./src/components/sortable/constants.ts